// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rzPDB","content":"styles_content__1mfyq","row":"styles_row__3bSqP","footer":"styles_footer__1yC2P","phraseLength":"styles_phraseLength__1co25"};